import { render } from "./Datetime.vue?vue&type=template&id=7be08da7"
import script from "./Datetime.vue?vue&type=script&lang=ts"
export * from "./Datetime.vue?vue&type=script&lang=ts"
script.render = render

export default script